var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "drfSmgCompanyCustomer" },
    [
      _c(
        "el-form",
        {
          staticClass: "form",
          attrs: { inline: true, disabled: !_vm.edit, "label-suffix": ":" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "270px" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "企业组中已包含商品分类限制，选中企业组可在限制品类中查看不支持品类；如需新增限制商品，请联系大润发新建企业组",
                                placement: "bottom",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning-outline",
                                staticStyle: {
                                  "font-weight": "bold",
                                  cursor: "pointer",
                                  "font-size": "13px",
                                },
                              }),
                            ]
                          ),
                          _c("span", [
                            _vm._v("【大润发扫码购】企业组（商品分类限制）"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.changeType },
                          model: {
                            value: _vm.rule_type,
                            callback: function ($$v) {
                              _vm.rule_type = $$v
                            },
                            expression: "rule_type",
                          },
                        },
                        _vm._l(_vm.list, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item.id, label: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "270px" } },
                    [
                      _c("template", { slot: "label" }, [_c("span")]),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: {
                            placeholder: "请选择",
                            disabled: _vm.isCompanyCodeDisabled,
                          },
                          model: {
                            value: _vm.company_code,
                            callback: function ($$v) {
                              _vm.company_code = $$v
                            },
                            expression: "company_code",
                          },
                        },
                        _vm._l(_vm.companyConfig.list, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              value: item.company_code,
                              label: item.company_name + "（" + item.id + "）",
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "限制品类", "label-width": "180px" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "270px" },
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 3, maxRows: 6 },
                          disabled: "",
                          placeholder: "请选择企业组",
                        },
                        model: {
                          value: _vm.currentCategoryName,
                          callback: function ($$v) {
                            _vm.currentCategoryName = $$v
                          },
                          expression: "currentCategoryName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }